import { getBaseExecutionContext } from './helpers/expression-functions';
import { evaluateParsedExpression, parse } from './helpers/expression-eval';
import {
  ExpressionDataFunction,
  ExpressionFunctionsCachedResult,
} from './types';

export function initialData(): ExpressionFunctionsCachedResult {
  return {
    [ExpressionDataFunction.firstBlockInCase]: {},
    [ExpressionDataFunction.lastBlockInCase]: {},
    [ExpressionDataFunction.firstBlockInVisit]: {},
    [ExpressionDataFunction.lastBlockInVisit]: {},
    [ExpressionDataFunction.nthBlockInVisit]: {},
    [ExpressionDataFunction.nthBlockInCase]: {},
    [ExpressionDataFunction.allVisits]: {},
    [ExpressionDataFunction.allBlocksInCase]: {},
    [ExpressionDataFunction.allBlocksInVisit]: {},
    [ExpressionDataFunction.block]: {},
    [ExpressionDataFunction.Case]: {},
    [ExpressionDataFunction.visit]: {},
    [ExpressionDataFunction.patient]: {},
    [ExpressionDataFunction.previousBlock]: {},
    [ExpressionDataFunction.previousVisit]: {},
    [ExpressionDataFunction.nextVisit]: {},
    [ExpressionDataFunction.selectedVisits]: {},
    [ExpressionDataFunction.hl7]: {},
    [ExpressionDataFunction.gdt]: {},
    [ExpressionDataFunction.file]: {},
    [ExpressionDataFunction.lastVisitInCase]: {},
    [ExpressionDataFunction.firstVisitInCase]: {},
    setValue(
      func: ExpressionDataFunction,
      argument: string | undefined,
      value: any
    ) {
      this[func][argument ?? ''] = value;
      return this;
    },
  };
}
export function createExpressionExecutionContext(
  backendQueryResult: ExpressionFunctionsCachedResult
): Record<string, any> {
  const expressionEvaluationContext: Record<string, any> =
    getBaseExecutionContext();

  Object.values(ExpressionDataFunction).forEach(
    (funcName: ExpressionDataFunction) => {
      expressionEvaluationContext[funcName] = (...args: string[]) =>
        backendQueryResult[funcName][(args ?? []).join('_')];
    }
  );
  return expressionEvaluationContext;
}

export function executeExpression(
  expression: string,
  data: ExpressionFunctionsCachedResult
): any {
  //throw new Error(JSON.stringify(data));
  const expressionExecutionContext = createExpressionExecutionContext(data);
  const result = executeExpressionInner(expression, expressionExecutionContext);
  if (result instanceof Date) {
    return result?.toString();
  }
  return result;
}

export function executeSimpleExpression(
  expression: string,
  data: Record<string, any>
): any {
  const executionContext = getBaseExecutionContext();
  return executeExpressionInner(expression, { ...executionContext, data });
}

const parsedExpressionsCache: Record<string, parse.Expression> = {};
function executeExpressionInner(expression: string, data: any): any {
  try {
    const ast =
      parsedExpressionsCache[expression] ??
      (parsedExpressionsCache[expression] = parse(expression));

    if (data === null) {
      return null;
    } else {
      const value = evaluateParsedExpression(ast, data);
      return value;
    }
  } catch (e) {
    console.log((e as { message: string }).message);
    return null;
  }
}
